(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = document.querySelector('.shopify-section-header');

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

      this.mobileMenu = this.querySelector('header-drawer');

      this.currentScrollTop = 0;

      this.preventHide = false;

      this.preventReveal = false;



      this.headerCoords = {};

      this.calcHeaderCoords();



      this.onScrollHandler = this.onScroll.bind(this);

      this.enableScroll();

    }



    disconnectedCallback() {

      this.disableScroll();

    }



    calcHeaderCoords() {

      const clientRect = this.getBoundingClientRect();

      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;

      this.headerCoords.bottom = pageYOffset + clientRect.bottom;

      this.headerCoords.top = pageYOffset + clientRect.top;

    }



    onScroll(event) {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.headerIsAlwaysSticky) {

        if (scrollTop > this.header.offsetHeight + 1) {

          this.header.classList.add('shopify-section-header-sticky');

        }



        if (scrollTop < this.header.offsetHeight) {

          this.header.classList.remove('shopify-section-header-sticky');

        }

      }



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {

        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {

          return;

        }

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {

        if (this.preventReveal) {

          return;

        }

        requestAnimationFrame(this.reveal.bind(this));

      } else if (scrollTop <= this.headerCoords.top) {

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

    }



    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    enableScroll() {

      window.addEventListener('scroll', this.onScrollHandler, false);

    }



    disableScroll() {

      window.removeEventListener('scroll', this.onScrollHandler);

    }

  }



  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
